// AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
// Welke taken de agenda laat zien. Uit `useAgendaData` gehaald omdat die hook
// aan Firestore hangt en dus niet te testen is; dit stuk wél.

import { isSubtask } from '../adressHelpers/taskKind'

/**
 * De taken die in de agenda thuishoren.
 *
 * Twee dingen vallen weg. Een roosterregel van een deelnemer die niet in de
 * lijst staat: die zou anders een rooster tonen voor iemand die er niet meer
 * werkt. Welke deelnemers erin staan bepaalt `agendaSchedulePersonas`: de
 * actieven, en de uitgestroomden met een uitstroomdatum — de weergave stopt hun
 * rooster na die dag (ADR-058). En een subtaak, in de oude én de nieuwe vorm: een subtaak is werk,
 * geen moment. De agenda toont de afspraak; het werk staat eronder. Zonder deze
 * regel verschijnt een subtaak met een datum als los blok in de agenda.
 *
 * @param {Array<object>|null|undefined} docs - De taken binnen het zichtbare bereik
 * @param {Array<string>|null|undefined} schedulePersonaIds - `ID` van elke deelnemer wiens rooster in de agenda hoort
 * @returns {Array<object>}
 */
const visibleAgendaDocs = (docs, schedulePersonaIds) => {
    const actief = Array.isArray(schedulePersonaIds) ? schedulePersonaIds : []
    return (Array.isArray(docs) ? docs : []).filter((doc) => {
        if (isSubtask(doc)) return false
        if (doc?.Type !== 'personaSchedule') return true
        return actief.includes(doc?.PersonaID)
    })
}

export default visibleAgendaDocs
